const KEY_PREFIX = 'fleetup.driver.pref.';

export type MenuStyle = 'wheel' | 'stack';

export function getPreference<T extends string>(key: string, fallback: T): T {
  if (typeof window === 'undefined') return fallback;
  try {
    const val = window.localStorage.getItem(KEY_PREFIX + key);
    return (val as T) ?? fallback;
  } catch {
    return fallback;
  }
}

export function setPreference(key: string, value: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(KEY_PREFIX + key, value);
  } catch {
    /* private mode, full disk, etc — silently no-op */
  }
}

export function getMenuStyle(): MenuStyle {
  return getPreference<MenuStyle>('menuStyle', 'stack');
}

export function setMenuStyle(style: MenuStyle): void {
  setPreference('menuStyle', style);
}
